module.exports = __webpack_public_path__ + "img/touXiang1.46109f9f.png";